// === Toast & Browser Notification ===

interface ToastItem {
  text: string;
  sessionId: string | null;
}

interface ActiveToast {
  element: HTMLDivElement;
  hideTimer: ReturnType<typeof setTimeout>;
  removeTimer: ReturnType<typeof setTimeout> | null;
}

// 模块内私有状态
const toastQueue: ToastItem[] = [];
let activeToast: ActiveToast | null = null;

// 依赖注入：点击 toast 时跳转 session（避免与 session 模块循环引���）
let _openSession: ((id: string) => void) | null = null;
export function setToastSessionOpener(fn: (id: string) => void): void {
  _openSession = fn;
}

function consumeToastQueue(): void {
  if (activeToast || toastQueue.length === 0) return;
  const next = toastQueue.shift()!;
  const toast = document.createElement('div');
  toast.className = 'toast-notification';
  toast.textContent = next.text;

  const closeToast = () => {
    if (!activeToast || activeToast.element !== toast) return;
    clearTimeout(activeToast.hideTimer);
    toast.classList.remove('show');
    activeToast.removeTimer = setTimeout(() => {
      toast.remove();
      activeToast = null;
      consumeToastQueue();
    }, 300);
  };

  if (next.sessionId && _openSession) {
    toast.style.cursor = 'pointer';
    toast.addEventListener('click', () => {
      _openSession!(next.sessionId!);
      closeToast();
    });
  }

  document.body.appendChild(toast);
  setTimeout(() => toast.classList.add('show'), 10);
  const hideTimer = setTimeout(closeToast, 5000);
  activeToast = { element: toast, hideTimer, removeTimer: null };
}

export function showToast(text: string, sessionId?: string | null): void {
  if (!text) return;
  toastQueue.push({ text: String(text), sessionId: sessionId ?? null });
  consumeToastQueue();
}

/** 通过 Service Worker 发送系统通知（任务完成时调用） */
export function showBrowserNotification(title: string, options: { status?: string; error?: string | null } = {}): void {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((reg) => {
      const failed = options.status === 'failed';
      const opts: NotificationOptions & { renotify?: boolean } = {
        body: failed
          ? `「${title}」任务失败${options.error ? `\n${String(options.error).slice(0, 160)}` : ''}`
          : `「${title}」任务完成`,
        tag: 'webcoding-task',
        renotify: true,
      };
      reg.showNotification(failed ? 'Webcoding 失败' : 'Webcoding', opts);
    }).catch((error) => {
      console.warn('[notify] failed to show notification', error);
    });
  }
}

/** 请求系统通知权限（首次登录时调用） */
export function requestNotificationPermission(): void {
  if ('Notification' in window && Notification.permission === 'default') {
    const result = Notification.requestPermission();
    if (result && typeof result.catch === 'function') {
      result.catch((error) => {
        console.warn('[notify] request permission failed', error);
      });
    }
  }
}
